import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import PopupMessage from "../components/PopupMessage";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import EditIcon from "@material-ui/icons/EditOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import PasswordIcon from "@material-ui/icons/LockOpenOutlined";
import SSOKeyIcon from "@material-ui/icons/VpnKeyOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 1500,
  },
});

class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      profileData: {},
      canEdit: false,
      editMode: false,
      editPassword: false,
      viewPopup: false,
      confirmPassword: "",
      warning: false,
      resultTitle: "",
      resultString: "",
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseNotify = this.onCloseNotify.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  onCloseNotify(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    fetch("on_logout_force", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userName: this.props.userName,
        realm: this.props.userRealm,
        r: new Date().getTime(),
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        if (window.sco_return_url) {
          if (!window.sco_return_url.includes("http")) {
            this.props.history.push(window.sco_return_url);
          } else {
            window.location.href = window.sco_return_url;
          }
        } else {
          this.props.history.push("/");
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
    this.setState({
      errorString: getErrorString(
        "user.login.retry",
        "Your existing session was disconnected. Please login."
      ),
    });
  }

  componentDidMount() {
    fetch("on_user_profile_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ profileData: reply.profileData });
          this.setState({ canEdit: reply.canEdit });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleEdit(e) {
    if (!this.state.editMode) {
      this.setState({ editMode: true });
    } else {
      if (this.props.viewOnly) {
        this.setState({
          errorString: getErrorString(
            "viewOnly.warning",
            "Operation not allowed in support mode."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.profileData.phone.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.phone.error",
            "Phone Number is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.profileData.email.length === 0) {
        this.setState({
          errorString: getErrorString(
            "company.email.error",
            "E-mail is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      this.saveChanges();
    }
  }

  handleEditPassword(e) {
    if (!this.state.editPassword) {
      this.setState({ editPassword: true });
    } else {
      if (this.props.viewOnly) {
        this.setState({
          errorString: getErrorString(
            "viewOnly.warning",
            "Operation not allowed in support mode."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (
        this.state.profileData.oldPassword == null ||
        this.state.profileData.oldPassword === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.oldpassword.error",
            "Old Password is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (
        this.state.profileData.newPassword == null ||
        this.state.profileData.newPassword === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.newpassword.error",
            "New Password is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (
        this.state.confirmPassword == null ||
        this.state.confirmPassword === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.confirmpassword.error",
            "Confirm Password is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.profileData.newPassword.length < 8) {
        this.setState({
          errorString: getErrorString(
            "login.passwordLength.error",
            "New Password must be at least 8 characters."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      if (this.state.confirmPassword !== this.state.profileData.newPassword) {
        this.setState({
          errorString: getErrorString(
            "login.passwordNotMatch.error",
            "New and Confirm Passwords do not match."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
      this.saveChanges();
    }
  }

  handleSSOKey(e) {
    fetch("on_user_ssokey_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ ssoKeyData: reply.profileData });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          }
          if (reply.warning) {
            this.setState({ resultString: reply.warningString });
            this.setState({
              resultTitle:
                "Use this code for accessing SAND Barcode Management:",
            });
            this.setState({ warning: true });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleCancel() {
    this.setState({ editMode: false });
    this.setState({ editPassword: false });
    this.componentDidMount();
  }

  handlePhone = (event) => {
    let myData = this.state.profileData;
    myData.phone = event.target.value;
    this.setState({ profileData: myData });
  };

  handleFax = (event) => {
    let myData = this.state.profileData;
    myData.fax = event.target.value;
    this.setState({ profileData: myData });
  };

  handleEmail = (event) => {
    let myData = this.state.profileData;
    myData.email = event.target.value;
    this.setState({ profileData: myData });
  };

  handleLanguage = (event) => {
    let myData = this.state.profileData;
    myData.language = event.target.value;
    this.setState({ profileData: myData });
  };

  handleOldPassword = (event) => {
    let myData = this.state.profileData;
    myData.oldPassword = event.target.value;
    this.setState({ profileData: myData });
  };

  handleNewPassword = (event) => {
    let myData = this.state.profileData;
    myData.newPassword = event.target.value;
    this.setState({ profileData: myData });
  };
  handleConfirmPassword = (event) => {
    this.setState({ confirmPassword: event.target.value });
  };

  handleQuestion = (event) => {
    let myData = this.state.profileData;
    myData.secretQuestion = event.target.value;
    this.setState({ profileData: myData });
  };

  handleAnswer = (event) => {
    let myData = this.state.profileData;
    myData.secretAnswer = event.target.value;
    this.setState({ profileData: myData });
  };

  saveChanges() {
    let myData = this.state.profileData;
    myData.secureToken = this.props.secureToken;
    this.setState({ profileData: myData });
    fetch("on_user_profile_save", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.profileData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (this.state.editPassword) {
            let myData = this.state.profileData;
            myData.newPassword = "";
            myData.oldPassword = "";
            this.setState({ profileData: myData });
            this.setState({ confirmPassword: "" });
          }
          this.setState({
            notifyString: "Your profile has been updated. Please re-login.",
          });
          this.setState({ viewPopup: true });
          this.setState({ editMode: false });
          this.setState({ editPassword: false });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        <Paper className={classes.toolbar}>
          <Toolbar>
            <Typography variant="h6" color="primary">
              {this.state.editMode
                ? t("editProfile.label")
                : this.state.editPassword
                ? t("changPassword.label")
                : t("profile.label")}
              &nbsp;&nbsp;
            </Typography>
            {this.state.canEdit && !this.state.editPassword && (
              <Button
                color="primary"
                onClick={(event) => this.handleEdit(event)}
              >
                {this.state.editMode && <SaveIcon />}
                {!this.state.editMode && <EditIcon />}&nbsp;{" "}
                {this.state.editMode ? t("save.button") : t("edit.button")}
              </Button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.canEdit && !this.state.editMode && (
              <Button
                color="primary"
                onClick={(event) => this.handleEditPassword(event)}
              >
                {this.state.editMode && <SaveIcon />}
                {!this.state.editMode && <PasswordIcon />}&nbsp;{" "}
                {this.state.editPassword
                  ? t("save.button")
                  : t("changPassword.label")}
              </Button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.canEdit &&
              this.state.profileData.allowSANDRegistration &&
              !this.state.editMode &&
              !this.state.editPassword && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleSSOKey(event)}
                >
                  {!this.state.editMode && <SSOKeyIcon />}&nbsp;
                  {t("ssoKey.label")}
                </Button>
              )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {(this.state.editMode || this.state.editPassword) && (
              <Button
                color="primary"
                onClick={(event) => this.handleCancel(event)}
              >
                <CancelIcon />
                &nbsp;{t("cancel.button")}
              </Button>
            )}
          </Toolbar>
        </Paper>
        <div className={classes.tableWrapper}>
          {this.state.errorString.length > 0 && !this.state.viewPopup && (
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          )}
          {this.state.viewPopup && this.state.resultString.length > 0 && (
            <PopupMessage
              title={this.state.resultTitle}
              text={this.state.resultString}
              error={this.state.warning}
              onClosePopup={this.onClosePopup}
            />
          )}
          {this.state.viewPopup && this.state.errorString.length > 0 && (
            <PopupMessage
              title="Error"
              text={this.state.errorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}
          {this.state.viewPopup && this.state.notifyString.length > 0 && (
            <PopupMessage
              title="Information"
              text={this.state.notifyString}
              error={false}
              onClosePopup={this.onCloseNotify}
            />
          )}

          {this.state.errorString.length === 0 &&
            !this.state.editMode &&
            !this.state.editPassword && (
              <table style={{ margin: 30 }}>
                <Paper elevation={6}>
                  <tr>
                    <td width="200">
                      {" "}
                      <Typography variant="subheading" color="primary">
                        {t("mainContact.label")}:{" "}
                      </Typography>
                    </td>
                    <td width="450"> {this.state.profileData.contact}</td>
                    <td width="200">
                      {" "}
                      <Typography variant="subheading" color="primary">
                        &nbsp;&nbsp;{t("yourCompName.label")}:{" "}
                      </Typography>
                    </td>
                    <td width="450"> {this.state.profileData.company}</td>
                  </tr>
                  <tr style={{ height: 10 }} />
                  <tr>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        {t("lan.label")}:&nbsp;&nbsp;
                      </Typography>
                    </td>
                    <td> {this.state.profileData.language}</td>
                  </tr>
                  <tr style={{ height: 10 }} />
                  <tr>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        {t("phoneNumber.label")}:{" "}
                      </Typography>
                    </td>
                    <td> {this.state.profileData.phone}</td>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        &nbsp;&nbsp;{t("faxNumber.label")}:{" "}
                      </Typography>
                    </td>
                    <td> {this.state.profileData.fax}</td>
                  </tr>
                  <tr style={{ height: 10 }} />
                  <tr>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        {t("emailAddress.label")}:{" "}
                      </Typography>
                    </td>
                    <td colSpan={3}> {this.state.profileData.email}</td>
                  </tr>
                  <tr style={{ height: 10 }} />
                  {!this.props.uiExclusionsList.includes("PROFILE_SQA") && (
                    <tr>
                      <td>
                        {" "}
                        <Typography variant="subheading" color="primary">
                          {t("secretQuestion.label")}:{" "}
                        </Typography>
                      </td>
                      <td> {this.state.profileData.secretQuestion}</td>
                      <td>
                        {" "}
                        <Typography variant="subheading" color="primary">
                          &nbsp;&nbsp;{t("secretAnswer.label")}:{" "}
                        </Typography>
                      </td>
                      <td> {this.state.profileData.secretAnswer}</td>
                    </tr>
                  )}
                </Paper>
              </table>
            )}
          {this.state.errorString.length === 0 && this.state.editMode && (
            <table style={{ margin: 30 }}>
              <Paper elevation={6}>
                <tr>
                  <td width="650">
                    <TextField
                      margin="dense"
                      id="phone"
                      label={t("phoneNumber.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 20,}}
                      defaultValue={this.state.profileData.phone}
                      onChange={this.handlePhone}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      &nbsp;(XXX) XXX - XXXX
                    </Typography>
                  </td>
                  <td width="650">
                    &nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="fax"
                      label={t("faxNumber.label")}
                      type="text"
                      inputProps={{maxLength: 20,}}
                      defaultValue={this.state.profileData.fax}
                      onChange={this.handleFax}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      &nbsp;&nbsp;&nbsp;(XXX) XXX - XXXX
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="caption">
                      {t("lan.label")}&nbsp;&nbsp;
                    </Typography>
                    <FormControl>
                      <NativeSelect
                        style={{
                          height: 25,
                          verticalAlign: "textTop",
                          margin: 0,
                        }}
                        defaultValue={this.state.profileData.language}
                        input={<Input id="language" />}
                        onChange={(event) => this.handleLanguage(event)}
                      >
                        <option value="English">{t("english.label")}</option>
                        <option value="French">{t("french.label")}</option>
                        <option value="Spanish">{t("spanish.label")}</option>
                      </NativeSelect>
                    </FormControl>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <TextField
                      margin="dense"
                      id="email"
                      label={t("emailAddress.label")}
                      type="text"
                      required
                      inputProps={{maxLength: 250,}}
                      fullWidth
                      defaultValue={this.state.profileData.email}
                      onChange={this.handleEmail}
                    />
                    <br />
                    <Typography variant="caption" color="primary">
                      {t("enterCorrectEmail.label")}
                    </Typography>
                  </td>
                </tr>
                {!this.props.uiExclusionsList.includes("PROFILE_SQA") && (
                  <tr>
                    <td>
                      <TextField
                        margin="dense"
                        id="question"
                        label={t("secretQuestion.label")}
                        type="text"
                        inputProps={{maxLength: 100,}}
                        fullWidth
                        defaultValue={this.state.profileData.secretQuestion}
                        onChange={this.handleQuestion}
                      />
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="answer"
                        label={t("secretAnswer.label")}
                        type="text"
                        inputProps={{maxLength: 50,}}
                        fullWidth
                        defaultValue={this.state.profileData.secretAnswer}
                        onChange={this.handleAnswer}
                      />
                    </td>
                  </tr>
                )}
              </Paper>
            </table>
          )}
          {this.state.errorString.length === 0 && this.state.editPassword && (
            <table style={{ margin: 30 }}>
              <Paper elevation={6}>
                <tr>
                  <td>
                    <TextField
                      margin="dense"
                      id="oldPass"
                      label={t("oldPassword.label")}
                      type="password"
                      required
                      defaultValue={this.state.profileData.oldPassword}
                      onChange={this.handleOldPassword}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      margin="dense"
                      id="newPass"
                      label={t("newPassword.label")}
                      type="password"
                      required
                      defaultValue={this.state.profileData.newPassword}
                      onChange={this.handleNewPassword}
                    />
                  </td>
                  <td>
                    <TextField
                      margin="dense"
                      id="confirmPass"
                      label={t("confirmPassword.label")}
                      type="password"
                      required
                      defaultValue={this.state.confirmPassword}
                      onChange={this.handleConfirmPassword}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <Typography variant="caption" color="primary">
                      {t("password.label")}
                    </Typography>
                  </td>
                </tr>
              </Paper>
            </table>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ProfilePage));
